export default "__VITE_ASSET__04ff0f36__"